export const homeContent = {
  heroTitle: 'YOYBUY Sheet',
  heroSubtitle: 'Умная система закупок из Китая. Управляйте заказами через электронные таблицы — быстро, прозрачно и без ошибок.',
  heroCta1: 'YOYBUY Sheet',
  heroCta2: 'Buy It Now',

  navDropdownLabel: 'Категории товаров',

  sectionFeaturedTitle: 'Популярные категории',
  sectionFeaturedSubtitle: 'Тысячи товаров из Китая с доставкой по всему миру',

  sectionAllCategoriesTitle: 'Все категории',
  sectionAllCategoriesTag: 'КАТАЛОГ',
  sectionAllCategoriesSubtitle: 'Выберите интересующую вас категорию и перейдите к покупкам',

  aboutTag: 'О СИСТЕМЕ',
  aboutTitle: 'YOYBUY Spreadsheet — это революция в закупках из Китая',
  aboutDescription: 'Мы создали систему, которая объединяет мощь электронных таблиц с удобством современных закупочных платформ. Больше никаких потерянных заказов, скрытых комиссий и путаницы с размерами. YOYBUY Sheet даёт вам полный контроль над каждым этапом — от выбора товара до отслеживания доставки.',
  aboutDescription2: 'Система уже помогла тысячам предпринимателей и частных покупателей организовать закупки из Китая эффективно и без стресса. Присоединяйтесь к сообществу умных покупателей.',

  ctaTitle: 'Готовы начать покупать',
  ctaHighlight: 'умнее',
  ctaSubtitle: 'Присоединяйтесь к тысячам довольных клиентов',

  articleSectionTitle: 'Блог YOYBUY',
  articleSectionTag: 'СТАТЬИ',
  articleSectionSubtitle: 'Узнайте больше о системе YOYBUY Spreadsheet и закупках из Китая',

  footerDescription: 'YOYBUY Sheet — интеллектуальная платформа для организации закупок из Китая с помощью электронных таблиц. Экономьте время, деньги и нервы.',
};